/**
 * Replaces JWTs in every string of a log event before it is sent to Datadog.
 * `forwardConsoleLogs: 'all'` forwards third-party console output too (e.g. the WAVV dialer
 * logging its `jwt`), so removing our own console calls is not enough. Must never throw.
 */

export const REDACTED_JWT = '[REDACTED_JWT]';

/**
 * header.payload.signature. The header is a JSON object starting `{"`, which base64url-encodes to `eyJ`;
 * anchoring on it keeps dotted strings like hostnames and versions from matching.
 */
const JWT_PATTERN = /eyJ[\w-]+\.[\w-]+\.[\w-]*/g;

/** Covers the message, error fields and causes, and any context merged onto the event. */
export function redactLogTokens(log: object): void {
  try {
    redactInPlace(log as Record<string, unknown>);
  } catch {
    // Leave the log as-is rather than break logging.
  }
}

/** Walks the whole event with an explicit stack, so nesting depth can't overflow the call stack. */
function redactInPlace(root: Record<string, unknown>): void {
  const visited = new WeakSet<object>([root]);
  const stack = [root];
  let node: Record<string, unknown> | undefined;
  while ((node = stack.pop())) {
    for (const key of Object.keys(node)) {
      const value = node[key];
      if (typeof value === 'string') {
        if (value.includes('eyJ')) node[key] = value.replace(JWT_PATTERN, REDACTED_JWT);
      } else if (value && typeof value === 'object' && !visited.has(value)) {
        visited.add(value);
        stack.push(value as Record<string, unknown>);
      }
    }
  }
}
